<!--
  画面名：-
  概要： QRをPDF出力する確認をするダイアログ
  備考：
-->

<!-- HTML -->
<template>
  <v-dialog v-model="isDialog" :width="450">
    <v-card>
      <!-- ダイアログのタイトル -->
      <v-card-title>
          <span class="headline"> {{ $language.LabelOutput }} </span>
      </v-card-title>

      <v-card-actions class="action-content">
        <v-layout align-center justify-center justify-space-around>
          <!-- 選択した従業員 -->
          <v-btn
            @click="outputPdf"
            small
            class="btn"
            :disabled="!selected"
          >
            {{ $language.LabelOutputSelect }}
          </v-btn>
          <!-- 全従業員 -->
          <v-btn
            @click="allOutputPdf"
            small
            class="btn"
          >
            {{ $language.LabelAllOutputPdf }}
          </v-btn>
        </v-layout>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- 閉じるボタン -->
        <v-btn color="blue darken-1" flat @click="closeDialog">{{$language.LabelClose}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<!-- /HTML -->

<script>

export default {
  props: {
    selected: { type: Boolean, default: false }
  },
  data () {
    return {
      // ダイアログの表示切替用
      isDialog: false
    }
  },
  methods: {
    // ダイアログ表示機能
    open () {
      this.isDialog = true
    },
    // ダイアログを閉じる機能
    closeDialog () {
      // ダイアログの表示をOFF
      this.isDialog = false
    },
    // 全件出力
    allOutputPdf () {
      this.closeDialog()
      this.$emit('allOutputPdf')
    },
    // 対象出力
    outputPdf () {
      this.closeDialog()
      this.$emit('outputPdf')
    }
  }
}
</script>
